import Vue from "vue";
import Vuex from "vuex";
import { parseTime } from "@/utils/utils.js"
//使用
Vue.use(Vuex);

const options = {
  state: {
    // 存储jwt
    Authorization: localStorage.getItem("Authorization")
      ? localStorage.getItem("Authorization")
      : "",
    // 存储行政区域
    administrativeName: localStorage.getItem("administrativeName")
      ? localStorage.getItem("administrativeName")
      : "",
    boxHeight: window.innerHeight,
    minBoxRight: false,
    isRefresh: "123",
    isHead: localStorage.getItem("isHead")
      ? localStorage.getItem("isHead")
      : "1",
    userType: sessionStorage.getItem("userType")
      ? sessionStorage.getItem("userType")
      : "",
    permission: sessionStorage.getItem("permission")
      ? sessionStorage.getItem("permission")
      : [],
    // 存储定期刷新时间
    refreshjwtTime: localStorage.getItem("refreshjwtTime")
    ? localStorage.getItem("refreshjwtTime")
    : null,
    userInfo: {}, //当前登录的用户信息
    mapWarnDetailsParams: {}, //地图预警点击传参
    mapWarnDetailsShow: false, //地图预警点击显示
    warnDetailsListShow: false, //预警详情列表显示
    issueDate: parseTime(new Date(), '{y}') //违法问题汇总时间
  },
  getters: {
    asideState: state => state.minBoxRight
  },
  mutations: {
    //   保存当前登录用户信息
    saveUserInfo(state, info) {
      state.userInfo = info;
      localStorage.setItem("userInfo", JSON.stringify(info));
    },
    // 修改jwt，并将jwt存入localStorage
    changeLogin(state, user) {
      state.Authorization = user.Authorization;
      localStorage.setItem("Authorization", user.Authorization);
    },
    setAdministrativeName(state, administrativeName) {
      state.administrativeName = administrativeName;
      localStorage.setItem("administrativeName", administrativeName);
    },
    setPermission(state, permission) {
      state.permission = permission;
      sessionStorage.setItem("permission", permission);
    },
    // 修改定期刷新时间
    setRefreshjwtTime(state, refreshjwtTime) {
      state.refreshjwtTime = refreshjwtTime;
      localStorage.setItem("refreshjwtTime", refreshjwtTime);
    },
    // 设置左侧菜单是否收起
    setMinBoxRight: (state, minBoxRight) => {
      state.minBoxRight = minBoxRight;
    },
    setIsHead: (state, isHead) => {
      state.isHead = isHead;
      localStorage.setItem("isHead", isHead);
    },
    setIsRefresh: (state, isRefresh) => {
      state.isRefresh = isRefresh;
    },
    setUserType: (state, userType) => {
      state.userType = userType;
    },
    setMapWarnDetailsParams: (state, params) => {
      state.mapWarnDetailsParams = params;
    },
    setMapWarnDetailsShow: (state, value) => {
      state.mapWarnDetailsShow = value;
    },
    setWarnDetailsListShow: (state, value) => {
      state.warnDetailsListShow = value;
    },
    setIssueDate: (state, value) => {
      state.issueDate = value;
    }
  }
};
export default new Vuex.Store(options);



// WEBPACK FOOTER //
// ./src/store/index.js